/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
import { AssignRolesDtoToJSON, CreateLocationDtoToJSON, CreateUserAccessDtoToJSON, CreateUserAccessResponseDtoFromJSON, GetUserAccessDtoFromJSON, LocationDtoFromJSON, UpdateUserAccessDtoToJSON, UpdateUserAccessResponseDtoFromJSON, } from '../models/index.js';
/**
 *
 */
export class UserAccessApi extends runtime.BaseAPI {
    /**
     * Replaces all existing roles for the user within the specified brand. Roles from other brands are preserved.
     * Assign roles to a user for a specific brand
     */
    async assignRolesRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling assignRoles().');
        }
        if (requestParameters['brandId'] == null) {
            throw new runtime.RequiredError('brandId', 'Required parameter "brandId" was null or undefined when calling assignRoles().');
        }
        if (requestParameters['assignRolesDto'] == null) {
            throw new runtime.RequiredError('assignRolesDto', 'Required parameter "assignRolesDto" was null or undefined when calling assignRoles().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/user-access/{userId}/brands/{brandId}/roles`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"brandId"}}`, encodeURIComponent(String(requestParameters['brandId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssignRolesDtoToJSON(requestParameters['assignRolesDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Replaces all existing roles for the user within the specified brand. Roles from other brands are preserved.
     * Assign roles to a user for a specific brand
     */
    async assignRoles(userId, brandId, assignRolesDto, initOverrides) {
        await this.assignRolesRaw({ userId: userId, brandId: brandId, assignRolesDto: assignRolesDto }, initOverrides);
    }
    /**
     * Provision new user access
     */
    async createRaw(requestParameters, initOverrides) {
        if (requestParameters['createUserAccessDto'] == null) {
            throw new runtime.RequiredError('createUserAccessDto', 'Required parameter "createUserAccessDto" was null or undefined when calling create().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/user-access`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserAccessDtoToJSON(requestParameters['createUserAccessDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserAccessResponseDtoFromJSON(jsonValue));
    }
    /**
     * Provision new user access
     */
    async create(createUserAccessDto, initOverrides) {
        const response = await this.createRaw({ createUserAccessDto: createUserAccessDto }, initOverrides);
        return await response.value();
    }
    /**
     * Create a new location
     */
    async createLocationRaw(requestParameters, initOverrides) {
        if (requestParameters['brandId'] == null) {
            throw new runtime.RequiredError('brandId', 'Required parameter "brandId" was null or undefined when calling createLocation().');
        }
        if (requestParameters['createLocationDto'] == null) {
            throw new runtime.RequiredError('createLocationDto', 'Required parameter "createLocationDto" was null or undefined when calling createLocation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/brands/{brandId}/locations`;
        urlPath = urlPath.replace(`{${"brandId"}}`, encodeURIComponent(String(requestParameters['brandId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLocationDtoToJSON(requestParameters['createLocationDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => LocationDtoFromJSON(jsonValue));
    }
    /**
     * Create a new location
     */
    async createLocation(brandId, createLocationDto, initOverrides) {
        const response = await this.createLocationRaw({ brandId: brandId, createLocationDto: createLocationDto }, initOverrides);
        return await response.value();
    }
    /**
     * Disables the user; the user cannot authenticate across any authentication methods but all data is preserved.
     * Disable a user (soft delete)
     */
    async disableRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling disable().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/user-access/{userId}/disable`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Disables the user; the user cannot authenticate across any authentication methods but all data is preserved.
     * Disable a user (soft delete)
     */
    async disable(userId, initOverrides) {
        await this.disableRaw({ userId: userId }, initOverrides);
    }
    /**
     * Get current user\'s access information
     */
    async getMyAccessRaw(requestParameters, initOverrides) {
        if (requestParameters['brandId'] == null) {
            throw new runtime.RequiredError('brandId', 'Required parameter "brandId" was null or undefined when calling getMyAccess().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/auth/v1/brands/{brandId}/my-access`;
        urlPath = urlPath.replace(`{${"brandId"}}`, encodeURIComponent(String(requestParameters['brandId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserAccessDtoFromJSON(jsonValue));
    }
    /**
     * Get current user\'s access information
     */
    async getMyAccess(brandId, initOverrides) {
        const response = await this.getMyAccessRaw({ brandId: brandId }, initOverrides);
        return await response.value();
    }
    /**
     * Removes the user\'s complete access by soft-deleting all brand and location memberships and the user record
     * Remove user access
     */
    async removeRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling remove().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/user-access/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Removes the user\'s complete access by soft-deleting all brand and location memberships and the user record
     * Remove user access
     */
    async remove(userId, initOverrides) {
        await this.removeRaw({ userId: userId }, initOverrides);
    }
    /**
     * Removes the user\'s access to the specified brand and all its locations
     * Remove user access to a specific brand
     */
    async removeBrandAccessRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling removeBrandAccess().');
        }
        if (requestParameters['brandId'] == null) {
            throw new runtime.RequiredError('brandId', 'Required parameter "brandId" was null or undefined when calling removeBrandAccess().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/user-access/{userId}/brands/{brandId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"brandId"}}`, encodeURIComponent(String(requestParameters['brandId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Removes the user\'s access to the specified brand and all its locations
     * Remove user access to a specific brand
     */
    async removeBrandAccess(userId, brandId, initOverrides) {
        await this.removeBrandAccessRaw({ userId: userId, brandId: brandId }, initOverrides);
    }
    /**
     * Updates the brand and location access for a user.
     * Update user brand access
     */
    async updateRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling update().');
        }
        if (requestParameters['updateUserAccessDto'] == null) {
            throw new runtime.RequiredError('updateUserAccessDto', 'Required parameter "updateUserAccessDto" was null or undefined when calling update().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/user-access/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserAccessDtoToJSON(requestParameters['updateUserAccessDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateUserAccessResponseDtoFromJSON(jsonValue));
    }
    /**
     * Updates the brand and location access for a user.
     * Update user brand access
     */
    async update(userId, updateUserAccessDto, initOverrides) {
        const response = await this.updateRaw({ userId: userId, updateUserAccessDto: updateUserAccessDto }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=UserAccessApi.js.map